/* Home v3 interactions (2026-10-15). Small on purpose: one delegated click listener, a rAF-throttled scroll
   listener on the hero, and a hero autoplay timer that only runs while the hero is on screen.
   Hero: arrows and dots wrap around (last -> first, first -> last); autoplay (seconds set in the theme editor,
   0 = off) pauses while the visitor touches/hovers/focuses the hero, when the tab is hidden, when the hero is off
   screen, and for visitors who asked for reduced motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';

  /* ---- hero helpers ---- */
  function heroState(hero) {
    var track = hero.querySelector('[data-hv-track]');
    var slides = track ? track.children.length : 0;
    var w = track ? track.clientWidth || 1 : 1;
    return { track: track, n: slides, w: w, i: track ? Math.round(track.scrollLeft / w) : 0 };
  }
  function heroGo(hero, target) {
    var st = heroState(hero);
    if (!st.track || st.n < 2) return;
    var next = (target + st.n) % st.n;
    var wrapping = (target >= st.n) || (target < 0);
    if (wrapping && !reduce) {
      /* jumping across all slides would be a long rewind: fade out, jump, fade in */
      st.track.style.transition = 'opacity .22s ease';
      st.track.style.opacity = '0';
      setTimeout(function () {
        st.track.scrollTo({ left: next * st.w, behavior: 'auto' });
        st.track.style.opacity = '1';
      }, 230);
    } else {
      st.track.scrollTo({ left: next * st.w, behavior: wrapping ? 'auto' : behavior });
    }
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-hv-nav]');
    if (nav) {
      var host = nav.closest('[data-hv-rail], [data-hv-hero]');
      if (!host) return;
      var dir = nav.getAttribute('data-hv-nav') === 'next' ? 1 : -1;
      if (host.hasAttribute('data-hv-hero')) { heroGo(host, heroState(host).i + dir); return; }
      var track = host.querySelector('[data-hv-track]');
      if (track) track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: behavior });
      return;
    }
    var dot = e.target.closest('[data-hv-dot]');
    if (dot) {
      var hero = dot.closest('[data-hv-hero]');
      if (hero) heroGo(hero, Number(dot.getAttribute('data-hv-dot')));
    }
  });


  /* ---- reels ("Shop the look", Instareel app) auto-scroll ----
     The app draws its slider after load, so wait for it, then step it along every few seconds. Pauses on touch/hover/
     focus and while off screen; goes back to the start after the last reel. If the app ever changes its markup this
     simply does nothing. */
  (function reelsAutoplay() {
    if (reduce) return;
    var tries = 0, slider = null;
    function find() {
      slider = document.querySelector('.reelify--slider');
      if (slider) return start();
      if (++tries < 40) setTimeout(find, 800);
    }
    function start() {
      var paused = false, visible = false, resumeT = null;
      function step() {
        if (paused || !visible || document.hidden) return;
        var card = slider.querySelector('[class*="reel-preview-card"]');
        var stepPx = card ? card.getBoundingClientRect().width + 16 : slider.clientWidth * 0.5;
        var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 6;
        slider.scrollTo({ left: atEnd ? 0 : slider.scrollLeft + stepPx, behavior: 'smooth' });
      }
      function hold() { paused = true; clearTimeout(resumeT); }
      function release(d) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; }, d); }
      slider.addEventListener('mouseenter', hold);
      slider.addEventListener('mouseleave', function () { release(800); });
      slider.addEventListener('focusin', hold);
      slider.addEventListener('focusout', function () { release(800); });
      slider.addEventListener('touchstart', hold, { passive: true });
      slider.addEventListener('touchend', function () { release(5000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.4 }).observe(slider);
      } else { visible = true; }
      setInterval(step, 3500);
    }
    if (document.readyState === 'complete') find(); else window.addEventListener('load', find, { once: true });
  })();

  var hero = document.querySelector('[data-hv-hero]');
  if (!hero) return;
  var track = hero.querySelector('[data-hv-track]');
  var dots = hero.querySelectorAll('[data-hv-dot]');
  if (!track || dots.length < 2) return;

  /* dots follow the scroll position */
  var ticking = false, current = 0;
  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i === current) return;
      current = i;
      for (var k = 0; k < dots.length; k++) dots[k].setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }, { passive: true });

  /* ---- autoplay ---- */
  var secs = Number(hero.getAttribute('data-hv-autoplay')) || 0;
  if (!secs || reduce) return;
  var paused = false, visible = true, timer = null, resumeT = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(tick, secs * 1000);
  }
  function tick() {
    if (!paused && visible && !document.hidden) heroGo(hero, heroState(hero).i + 1);
    schedule();
  }
  function hold() { paused = true; clearTimeout(resumeT); }
  function release(delay) { clearTimeout(resumeT); resumeT = setTimeout(function () { paused = false; schedule(); }, delay || 600); }
  hero.addEventListener('mouseenter', hold);
  hero.addEventListener('mouseleave', function () { release(600); });
  hero.addEventListener('focusin', hold);
  hero.addEventListener('focusout', function () { release(600); });
  hero.addEventListener('touchstart', hold, { passive: true });
  hero.addEventListener('touchend', function () { release(4000); }, { passive: true });
  hero.addEventListener('touchcancel', function () { release(4000); }, { passive: true });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.3 }).observe(hero);
  }
  /* start after the page has finished loading, so autoplay never competes with LCP */
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule, { once: true });
})();
